
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js'
import { mapState } from 'vuex'

import VueImageLightboxCarousel from '@/components/lightbox/VueImageLightboxCarousel.vue'
import AppCarousel from '@/components/ui/AppCarousel'

const commonCarouselOptions = {
  preloadImages: false
}

export default {
  mdiArrowLeft,
  mdiArrowRight,
  components: {
    VueImageLightboxCarousel,
    AppCarousel
  },
  data () {
    return {
      showLightbox: false,
      mainCarousel: null,
      thumbsCarousel: null
    }
  },
  computed: {
    ...mapState('product', {
      product: state => state.data,
      status: state => state.data?.auction?.status
    }),
    style () {
      return ['sold', 'failed'].includes(this.status) ? 'opacity: 0.5' : ''
    },
    mainCarouselOptions () {
      return {
        ...commonCarouselOptions,
        controller: { control: this.thumbsCarousel }
      }
    },
    thumbsCarouselOptions () {
      return {
        ...commonCarouselOptions,
        centeredSlides: true,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        controller: { control: this.mainCarousel }
      }
    }
  },
  methods: {
    openLightbox (index) {
      this.showLightbox = true

      this.$refs.lightboxCarousel.showImage(index)
    },
    onMainCarouselInit (carousel) {
      this.mainCarousel = carousel
    },
    onThumbsCarouselInit (carousel) {
      this.thumbsCarousel = carousel
    }
  }
}
